"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.todayAtMidnight = todayAtMidnight;
exports.todayAtMidnightString = todayAtMidnightString;
exports.formatDate = formatDate;
exports.parseDateString = parseDateString;
exports.getWeekDayFromStart = getWeekDayFromStart;
exports.getWeekDayFromEnd = getWeekDayFromEnd;
exports.getClosestWeekday = getClosestWeekday;
exports.addDayCardinality = addDayCardinality;
exports.formatWeeksFromEnd = formatWeeksFromEnd;
exports.months = exports.weekdays = exports.DATE_FORMAT = void 0;

var _format = _interopRequireDefault(require("date-fns/format"));

var _parse = _interopRequireDefault(require("date-fns/parse"));

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _addWeeks = _interopRequireDefault(require("date-fns/addWeeks"));

var _getDaysInMonth = _interopRequireDefault(require("date-fns/getDaysInMonth"));

var _getDay = _interopRequireDefault(require("date-fns/getDay"));

var _getDate = _interopRequireDefault(require("date-fns/getDate"));

var _isSunday = _interopRequireDefault(require("date-fns/isSunday"));

var _isSaturday = _interopRequireDefault(require("date-fns/isSaturday"));

var _startOfToday = _interopRequireDefault(require("date-fns/startOfToday"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var DATE_FORMAT = "yyyy-MM-dd";
exports.DATE_FORMAT = DATE_FORMAT;
var weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
exports.weekdays = weekdays;
var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
exports.months = months;

function todayAtMidnight() {
  return (0, _startOfToday.default)();
}

function todayAtMidnightString() {
  return formatDate(todayAtMidnight());
}

function formatDate(date) {
  return (0, _isValid.default)(date) ? (0, _format.default)(date, DATE_FORMAT) : "9999-12-31";
}

function parseDateString(dateString) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DATE_FORMAT;
  return (0, _parse.default)(dateString, dateFormat, todayAtMidnight());
}

function getWeekDayFromStart(_ref) {
  var date = _ref.startOfMonth,
      targetDay = _ref.targetDay,
      targetWeek = _ref.targetWeek;
  var day = (0, _getDay.default)(date); // if the target day is later in the week, then we advance to it.

  if (targetDay >= day) {
    date = (0, _addDays.default)(date, targetDay - day);
  } else {
    date = (0, _addDays.default)(date, 7 - (day - targetDay));
  }

  if (targetWeek > 1) {
    date = (0, _addWeeks.default)(date, targetWeek - 1);
  }

  return date;
}

function getWeekDayFromEnd(_ref2) {
  var date = _ref2.startOfMonth,
      targetDay = _ref2.targetDay,
      targetWeekNum = _ref2.targetWeekNum;
  var day = (0, _getDay.default)(date); // if the target day is later in the week, then we advance to it.

  if (targetDay >= day) {
    date = (0, _addDays.default)(date, targetDay - day);
  } else {
    date = (0, _addDays.default)(date, 7 - (day - targetDay));
  } // okay, now we've made it to the first xday of the month.
  // return formatDate(date);
  // so we're gonna get the date of the month.


  var dateInMonth = (0, _getDate.default)(date);
  var daysInMonth = (0, _getDaysInMonth.default)(date); // and use it to find the last xday of the month

  var deltaToLastWeek = Math.floor((daysInMonth - dateInMonth) / 7);
  date = (0, _addWeeks.default)(date, deltaToLastWeek - targetWeekNum);
  return date;
}

function getClosestWeekday(val) {
  if ((0, _isSunday.default)(val)) {
    return (0, _addDays.default)(val, 1);
  } else if ((0, _isSaturday.default)(val)) {
    return (0, _addDays.default)(val, -1);
  } else {
    return val;
  }
}

function addDayCardinality(label) {
  if (label.match(/(^|[^1])1$/)) {
    label += "st";
  } else if (label.match(/(^|[^1])2$/)) {
    label += "nd";
  } else if (label.match(/(^|[^1])3$/)) {
    label += "rd";
  } else {
    label += "th";
  }

  return label;
}

function formatWeeksFromEnd(day, daysInMonth) {
  var lastWeekNum = Math.floor((daysInMonth - day) / 7);

  switch (lastWeekNum) {
    case 0:
      return "last";

    case 1:
      return "2nd to last";

    case 2:
      return "3rd to last";

    case 3:
      return "4th to last";

    case 4:
      return "5th to last";

    default:
      throw new Error("Cannot calculate weekNum from ".concat(day, ", ").concat(daysInMonth));
  }
}